import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../../components/Loading";
import DropDownMenu from './Dropdown'
import { updateEvent } from "../../../services/events";
import _, { set, times, wrap } from 'lodash';
import { uploadPhoto } from "../../../services/documents";
import '../../../../node_modules/react-grid-layout/css/styles.css';
import '../../../../node_modules/react-resizable/css/styles.css';
import RGL, { WidthProvider } from 'react-grid-layout';
import MDEditor from '@uiw/react-md-editor';
import RemoveSvg from '../../../svgs/RemoveSvg'
import FileDropzone from '../../../components/FileDropzone'
import { getImageFileAspectRatio } from '../../../utils/util';
import SaveButton from '../../../svgs/SaveButton'
import RefreshButton from "../../../svgs/RefreshButton";

const ReactGridLayout = WidthProvider(RGL);
const rowHeight = 90
const numOfRow = 5
const convertToLayout = (data) => { return data?.map((item, index) => ({ i: `${index}`, x: 0, y: index * numOfRow, w: 1, h: numOfRow, data: item })) || [] }

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isloading, setIsloading] = useState(false)

    const onDropImageFile = (item, index) => async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 5) {
            alert(`File size must be within 5 MB`)
            return
        }

        const aspectRatio = await getImageFileAspectRatio(file);

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, id, props.data?.details[index]?.id || Date.now());
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                await updateEvent(props.token?.token, id, {
                    details: props.data?.details?.map((item, i) => {
                        if (i === index) {
                            item.url = filepath
                            item.aspectRatio = aspectRatio
                        }
                        return item
                    })
                })

                if (props.onEditKey) props.onEditKey(item, index, 'url', filepath)
            }
        }
        setIsloading(false);
    }


    const [layout, setlayout] = useState(convertToLayout(props.data?.details || []));
    useEffect(() => {
        //work around for issue of ReactGridLayout not updating width
        window.dispatchEvent(new Event('resize'));
    }, [layout]);
    useEffect(() => {
        setlayout(convertToLayout(props.data?.details || []))
    }, [props.data])

    const onDragStop = useCallback((layout) => (layout_, oldItem, newItem) => {
        const clonelayout = [...layout_]//_.cloneDeep(layout);
        const index = _.findIndex(layout, { 'i': oldItem.i })
        let dragY = clonelayout[index].y
        if (layout[index].y < dragY) {
            for (let i in layout) {
                if (layout[i].y <= dragY && layout[i].y > layout[index].y)
                    clonelayout[i].y = layout[i].y - 1
            }
        } else if (layout[index].y > dragY) {
            for (let i in layout) {
                if (layout[i].y >= dragY && layout[i].y < layout[index].y)
                    clonelayout[i].y = layout[i].y + 1
            }
        } else return
        clonelayout[index].y = dragY
        setlayout(clonelayout)
        if (props.updateOrder) props.updateOrder(layout, clonelayout)
    }, [layout])

    const onAddCard = () => { if (props.onAddCard) props.onAddCard() }
    const onDelete = (item, index) => () => { if (props.onDelete) { props.onDelete(item, index) } };
    const onEditKey = (item, index, key) => (e) => { if (props.onEditKey) props.onEditKey(item, index, key, e.target.value) };

    const handleSelectQuestionType = (item, index) => (type, typeIndex) => {
        if (props.onEditKey) props.onEditKey(item, index, 'type', type === '文字' ? 'text' : 'image');
    }
    const save = async () => {
        setIsloading(true);
        let res = await updateEvent(props.token?.token, id, {
            details: props.data?.details
        })
        if (res.errno) {
            alert(res.message || '儲存失敗')
        } else {
            if (res.result) {
                alert('儲存成功')
            }
        }
        setIsloading(false);
    }


    return (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
            <div className='flex flex-col w-full'>
                <div className='w-full flex flex-row w-full items-center gap-[16px] justify-between py-[2px] px-[16px] text-[14px] font-[700]'>
                    <div className='w-[20px]'></div>
                    <div className='w-[16px]'>#</div>
                    <div className='flex-1'>內容</div>
                </div>
                <ReactGridLayout
                    className='layout'
                    layout={layout}
                    cols={1}
                    rowHeight={rowHeight}
                    maxRows={layout.length * numOfRow}
                    preventCollision={true}
                    allowOverlap={true}
                    isDraggable={true}
                    isResizable={false}
                    onDragStop={onDragStop(layout)}
                    draggableHandle='.drag-handle'
                    style={{ height: layout.length * ((rowHeight + 10) * numOfRow), margin: 0, padding: 0 }}
                >
                    {layout?.map((item, index) => (
                        <div
                            key={item.i}
                            className='flex flex-row w-full items-start py-[8px] gap-[16px] justify-between px-[4px] rounded-[7px]'
                            style={{ border: '2px solid #B9B9B9', height: rowHeight }}
                        >
                            <div className='drag-handle cursor-pointer w-[20px]'>
                                <DragIcon />
                            </div>
                            <div className='w-[16px]'>{Number(index) + 1}</div>
                            <div className='flex-[1] flex flex-col gap-[8px] h-[100%]' style={{ overflowY: 'auto' }}>

                                <div className='flex flex-row w-full gap-[16px] flex-wrap'>

                                    <div className='flex flex-col'>
                                        <div className='font-[700]'>類型</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={handleSelectQuestionType(item, index)}
                                                value={props.data?.details[index]?.type === 'text' ? '文字' : props.data?.details[index]?.type === 'image' ? '圖片' : (props.data?.details[index]?.type || '--- 無 ---')}
                                                minWidth={250}
                                                options={['文字', '圖片']}
                                            />
                                        </div>
                                    </div>

                                    {props.data?.details[index]?.type === 'text' && <div className='flex flex-col'>
                                        <div className='font-[700]'>這是一個標題?</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={(option, optionIndex) => {
                                                    if (props.onEditKey) props.onEditKey(item, index, 'isTitle', option === '是');
                                                }}
                                                value={props.data?.details[index]?.isTitle ? '是' : '否'}
                                                minWidth={250}
                                                options={['是', '否']}
                                            />
                                        </div>
                                    </div>}
                                    {props.data?.details[index]?.type === 'image' && <div className='flex flex-col'>
                                        <div className='font-[700]'>影像佔據全寬(沒有邊距)?</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={(option, optionIndex) => {
                                                    if (props.onEditKey) props.onEditKey(item, index, 'isFullWidth', option === '是');
                                                }}
                                                value={props.data?.details[index]?.isFullWidth ? '是' : '否'}
                                                minWidth={250}
                                                options={['是', '否']}
                                            />
                                        </div>
                                    </div>}
                                    {props.data?.details[index]?.type === 'image' && <div className='flex flex-col'>
                                        <div className='font-[700] flex flex-row items-end'>
                                            使用自訂寬度?
                                        </div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={(option, optionIndex) => {
                                                    if (props.onEditKey) {
                                                        if(option === '是'){
                                                            props.onEditKey(item, index, 'isCustomWidth', true);
                                                            props.onEditKey(item, index, 'width', '100%');
                                                            props.onEditKey(item, index, 'justifyContent', 'center');
                                                        }else{
                                                            props.onEditKey(item, index, 'isCustomWidth', false);
                                                            props.onEditKey(item, index, 'width', null);
                                                            props.onEditKey(item, index, 'justifyContent', null);
                                                        }
                                                    }
                                                }}
                                                value={props.data?.details?.[index]?.isCustomWidth ? '是' : '否'}
                                                minWidth={250}
                                                options={['是', '否']}
                                            />
                                        </div>
                                    </div>
                                    }
                                    {props.data?.details[index]?.type === 'image' && props.data?.details[index]?.isCustomWidth&& <div className='flex flex-col'>
                                        <div className='font-[700] flex flex-row items-end'>
                                            自訂寬度 (0-100%):
                                        </div>
                                        <div className='flex flex-row'>
                                        {props.data?.details?.[index]?.width || '100%'}
                                           <input
                                                type="range"
                                                min="0"
                                                max="100"
                                                value={props.data?.details?.[index]?.width.replace('%', '') || '100'}
                                                onChange={(e) => {
                                                    if (props.onEditKey) {
                                                        props.onEditKey(item, index, 'width', `${e.target.value}%`);
                                                    }
                                                }
                                                }
                                                className='w-full'
                                            />
                                        </div>
                                    </div>
                                    }
                                    {props.data?.details[index]?.type === 'image' && props.data?.details[index]?.isCustomWidth&& <div className='flex flex-col'>
                                        <div className='font-[700]'>影像對齊方式</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={(option, optionIndex) => {
                                                    if (props.onEditKey) props.onEditKey(item, index, 'justifyContent', option === '左' ? 'flex-start' : option === '中' ? 'center' : option === '右' ? 'flex-end' : null);
                                                }}
                                                value={props.data?.details?.[index]?.justifyContent === 'flex-start' ? '左' : props.data?.details?.[index]?.justifyContent === 'center' ? '中' : props.data?.details?.[index]?.justifyContent === 'flex-end' ? '右' : '--- 無 ---'}
                                                minWidth={250}
                                                options={['左', '中', '右']}
                                            />
                                        </div>
                                    </div>}
                                    {props.data?.details[index]?.type === 'image' && <div className='flex flex-col'>
                                        <div className='font-[700] flex flex-row items-end'>
                                            點擊影像重新定向到其他頁面?
                                        </div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={(option, optionIndex) => {
                                                    if (props.onEditKey) props.onEditKey(item, index, 'redirect', option === '是' ? { type: 'in-app', path: null } : null);
                                                }}
                                                value={props.data?.details?.[index]?.redirect ? '是' : '否'}
                                                minWidth={250}
                                                options={['是', '否']}
                                            />
                                        </div>
                                    </div>}
                                    {(props.data?.details?.[index]?.type === 'image' && props.data?.details?.[index]?.redirect) &&
                                        <div className='flex flex-col'>
                                            <div className='font-[700]'>定向類型</div>
                                            <div className='flex flex-row'>
                                                <DropDownMenu
                                                    select={(option, optionIndex) => {
                                                        if (props.onEditKey) props.onEditKey(item, index, 'redirect', { ...(props.data?.details?.[index].redirect || {}), type: option === '無' ? null : option });
                                                    }}
                                                    value={props.data?.details?.[index]?.redirect?.type || '--- 無 ---'}
                                                    minWidth={250}
                                                    options={['無', 'in-app', 'webview', 'external-web', 'alert']}
                                                />
                                            </div>
                                        </div>
                                    }

                                    {(props.data?.details?.[index]?.type === 'image') && ['webview', 'external-web'].includes(props.data?.details?.[index]?.redirect?.type)
                                        && <div className='flex flex-col min-w-[400px]'>
                                            <div className='font-[700]'>網站網址</div>
                                            <div className='flex flex-row'>
                                                <input value={props.data?.details?.[index]?.redirect?.path || ''} onChange={(e) => {
                                                    if (props.onEditKey) props.onEditKey(item, index, 'redirect', { ...(props.data?.details?.[index].redirect || {}), path: e.target.value })
                                                }} placeholder='網址' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                            </div>
                                        </div>}
                                    {(props.data?.details?.[index]?.type === 'image') && ['alert'].includes(props.data?.details?.[index]?.redirect?.type) && <div className='flex flex-col min-w-[400px]'>
                                        <div className='font-[700]'>彈出訊息</div>
                                        <div className='flex flex-row'>
                                            <input value={props.data?.details?.[index]?.redirect?.data || ''} onChange={(e) => {
                                                if (props.onEditKey) props.onEditKey(item, index, 'redirect', { ...(props.data?.details?.[index].redirect || {}), data: e.target.value })
                                            }} placeholder='訊息' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                        </div>
                                    </div>}
                                    {(props.data?.details?.[index]?.type === 'image') && ['in-app'].includes(props.data?.details?.[index]?.redirect?.type) && <div className='flex flex-col min-w-[400px]'>
                                        <div className='font-[700]'>應用程式內定向路徑</div>
                                        <div className='flex flex-row'>
                                            <input value={props.data?.details?.[index]?.redirect?.path || ''} onChange={(e) => {
                                                if (props.onEditKey) props.onEditKey(item, index, 'redirect', { ...(props.data?.details?.[index].redirect || {}), path: e.target.value })
                                            }} placeholder='路徑' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                        </div>
                                    </div>}
                                    {(props.data?.details?.[index]?.type === 'image') && ['in-app'].includes(props.data?.details?.[index]?.redirect?.type) && <div className='flex flex-col min-w-[400px]'>
                                        <div className='font-[700]'>應用程式內定向路徑參數</div>
                                        <div className='flex flex-row'>
                                            <input value={props.data?.details?.[index]?.redirect?.params?._id || ''} onChange={(e) => {
                                                if (props.onEditKey) props.onEditKey(item, index, 'redirect', { ...(props.data?.details?.[index].redirect || {}), params: { _id: e.target.value } })
                                            }} placeholder='路徑參數' className='rounded-[7px] px-[8px] py-[4px] font-[400] w-full' />
                                        </div>
                                    </div>}
                                </div>

                                {props.data?.details[index]?.type === 'text' && <div className="flex flex-col w-full">
                                    <textarea onChange={
                                        (e) => { if (props.onEditKey) props.onEditKey(item, index, 'content', e.target.value) }
                                    } className="w-full bg-[#FFFFFF80] border-[#8D876C] border-[1px] text-black p-[8px] rounded-[7px] min-h-[120px]" value={props.data?.details[index]?.content || ""} />
                                </div>}

                                {props.data?.details[index]?.type === 'image' && <div className="flex flex-col w-full">
                                    <div className='w-full flex flex-row max-w-[600px] min-w-[400px] gap-[8px] mt-[8px]'>
                                        {props.data?.details[index]?.url && <div className='relative w-full'>
                                            {
                                                props.data?.details[index]?.url
                                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={props.data?.details[index]?.url} alt='image' />
                                                    : <div>
                                                    </div>
                                            }
                                            <div onClick={() => {
                                                if (props.onEditKey) props.onEditKey(item, index, 'url', null)
                                            }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                                <RemoveSvg />
                                            </div>
                                        </div>}
                                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                                            <FileDropzone onDropFile={onDropImageFile(item, index)} data={props.data?.details[index]} />
                                        </div>
                                    </div>
                                </div>}





                            </div>
                            <div className='cursor-pointer' onClick={onDelete(item, index)}>
                                <RemoveIcon />
                            </div>
                        </div>
                    ))}
                </ReactGridLayout>
                <div className='flex flex-row mt-[16px] p-[10px]'>
                    <div
                        className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#9f9f8b]'
                        style={{ border: '1px solid rgb(145, 151, 112)' }}
                        onClick={onAddCard}
                    >
                        <AddSvg /> 添加內容
                    </div>
                </div>
            </div>

            <div className="flex flex-row items-center justify-start w-full gap-[16px] mt-[24px] pl-[16px]">
                <div onClick={save} className="cursor-pointer hover:opacity-80">
                    <SaveButton/>
                </div>
                <div onClick={props.refresh} className="cursor-pointer hover:opacity-80">
                    <RefreshButton/>
                </div>
            </div>
            {isloading && <LoadingPage />}
        </div>
    );
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)


const AddSvg = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="M11.408 6.935h-4.5v4.5h-1.5v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5Z"
        />
    </svg>
)



const DragIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={17}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#000"
                d="M2 12.311h12v-1.333H2v1.333Zm0-3.333h12V7.644H2v1.334ZM2 4.31v1.333h12V4.311H2Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 .311h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)

const RemoveIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={21}
        fill="none"
        {...props}
    >
        <path
            fill="#212121"
            d="M1.364 18.15a2.238 2.238 0 0 0 2.231 2.231h8.926a2.238 2.238 0 0 0 2.232-2.231V4.76H1.363v13.39ZM3.595 6.992h8.926V18.15H3.595V6.992Zm8.368-5.578L10.848.298h-5.58L4.154 1.414H.248v2.231h15.62V1.414h-3.905Z"
        />
    </svg>
)